import type { ContentType, VirtualFile } from "@pdfking/pdfengine"
import { IsString, JSONDecode } from "@pdfking/tfunc"
import { CreateRemoteFile } from "@pdfking/workflow/actions/pdfengine/Functions"
import { url_decode } from "@pdfking/workflow/utils/urlutilities"
import merge from "rfuncs/functions/merge"

import get_media_urls from "../naming/get_media_urls"
import guess_filename from "../naming/guess_filename"
import make_from_filedata from "../naming/make_from_filedata"
import split_filename from "../naming/split_filename"

type NewFileFromRemoteIdOptions = {
  remote_id: string
  remote_name: string
  folder: string
  type: ContentType
}

export default async (
  filelist: NewFileFromRemoteIdOptions[] | string | undefined
): Promise<Record<string, VirtualFile>> => {
  let deserialized: NewFileFromRemoteIdOptions[] = IsString(filelist)
    ? JSONDecode(filelist)
    : filelist || []

  const result = {} as Record<string, VirtualFile>

  for (const { remote_id, remote_name, folder, type } of deserialized) {
    const path = make_from_filedata(
      merge(split_filename(guess_filename(url_decode(remote_name))), {
        folder,
      })
    )

    result[path] = await CreateRemoteFile({
      mirrors: get_media_urls(remote_id),
      file_meta: {
        remote_id,
        remote_name,
      },
      type,
    })
  }

  return result
}
